import { useState } from 'react'
import { toast } from 'react-toastify'
import { api } from '../../services/api'
import { validateEmail } from '../../utils/validation'
import { ValidatedInput } from '../../components/ValidatedInput'
import { AuthContainer, AuthCard, Form, ButtonContainer, Divider, BackText, StyledLink } from './styles'

export function ForgotPassword() {
  const [email, setEmail] = useState('')
  const [touched, setTouched] = useState({})
  const [errors, setErrors] = useState({})
  const [isLoading, setIsLoading] = useState(false)
  const [submitted, setSubmitted] = useState(false)

  const validateField = (name, value) => {
    let error = ''

    if (name === 'email') {
      if (!value) {
        error = 'Email é obrigatório'
      } else if (!validateEmail(value)) {
        error = 'Email inválido'
      }
    }

    setErrors((prev) => ({ ...prev, [name]: error }))
    return !error
  }

  const onBlur = (name) => {
    setTouched((prev) => ({ ...prev, [name]: true }))
    if (name === 'email') validateField(name, email)
  }

  const handleSubmit = async (e) => {
    e.preventDefault()

    setTouched({ email: true })
    const emailValid = validateField('email', email)

    if (!emailValid) {
      return
    }

    setIsLoading(true)

    try {
      await api.post('/auth/password-reset/request', { email })
      setSubmitted(true)
      toast.info('Se o email existir, você receberá instruções para redefinir sua senha.')
    } catch (error) {
      toast.info('Se o email existir, você receberá instruções para redefinir sua senha.')
      setSubmitted(true)
    } finally {
      setIsLoading(false)
    }
  }

  const isFormValid = !errors.email && email

  if (submitted) {
    return (
      <AuthContainer>
        <AuthCard>
          <h1>Email Enviado</h1>
          <p>Se o email informado estiver cadastrado, você receberá instruções para redefinir sua senha.</p>
          <p>Verifique sua caixa de entrada e spam.</p>

          <Divider />

          <BackText>
            <StyledLink to="/login">Voltar para Login</StyledLink>
          </BackText>
        </AuthCard>
      </AuthContainer>
    )
  }

  return (
    <AuthContainer>
      <AuthCard>
        <h1>Esqueceu a senha?</h1>
        <p>Digite seu email para receber instruções de recuperação</p>

        <Form onSubmit={handleSubmit}>
          <ValidatedInput
            name="email"
            type="email"
            label="Email"
            value={email}
            onChange={(e) => {
              setEmail(e.target.value)
              if (touched.email) validateField('email', e.target.value)
            }}
            onBlur={() => onBlur('email')}
            errors={errors}
            touched={touched}
            placeholder="seu@email.com"
            autoComplete="email"
          />

          <ButtonContainer>
            <button type="submit" disabled={!isFormValid || isLoading}>
              {isLoading ? 'Enviando...' : 'Enviar instruções'}
            </button>
          </ButtonContainer>
        </Form>

        <Divider />

        <BackText>
          <StyledLink to="/login">Voltar para Login</StyledLink>
        </BackText>
      </AuthCard>
    </AuthContainer>
  )
}
